import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

export const faqs = [
  {
    q: "What areas do you serve?",
    a: "We're based in Tampa and serve the entire bay area, including Clearwater, St. Petersburg, Brandon, Riverview, Wesley Chapel, Lutz, Oldsmar, Carrollwood, Temple Terrace, Valrico, Plant City, Land O' Lakes, and Palm Harbor — also serving Dunedin, Largo, Pinellas Park, Safety Harbor, and Apollo Beach.",
  },
  {
    q: "Do I need to be home during the cleaning?",
    a: "Not at all. Many of our clients provide entry instructions or a lockbox code and come home to a spotless house. Our team is background-checked and trained to treat your home with complete respect whether you're there or not.",
  },
  {
    q: "Do you bring your own cleaning supplies and equipment?",
    a: "Yes — we arrive fully equipped with professional products and equipment. If you prefer specific products (or have allergies or pets we should plan around), just let us know and we'll happily use what works for your home.",
  },
  {
    q: "What's the difference between a standard cleaning and a deep cleaning?",
    a: "A standard cleaning maintains a home that's already in good shape — surfaces, bathrooms, kitchens, and floors. A deep cleaning adds the buildup areas: inside the oven and fridge, baseboards, window tracks, vents, grout, and more. If it's your first professional cleaning, we usually recommend starting with a deep clean.",
  },
  {
    q: "Are you available on weekends?",
    a: "Yes — we're open Saturday from 8:00 AM to 6:00 PM. Sunday we're closed, but Monday through Saturday our crews are ready to help, which works well for Airbnb turnovers and busy family schedules.",
  },
  {
    q: "How do I get a quote?",
    a: "Just call (978) 564-5018 or fill out our free estimate form. Tell us about your space — bedrooms, bathrooms, and the type of cleaning you need — and we'll send you a clear, no-pressure quote, usually the same day.",
  },
];

const FAQSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-max max-w-3xl">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            FAQ
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Frequently Asked <span className="text-gradient-primary">Questions</span>
          </motion.h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.4 }}
            >
              <AccordionItem
                value={`faq-${i}`}
                className="bg-card rounded-xl border border-border px-6 data-[state=open]:shadow-md data-[state=open]:border-primary/20 transition-all"
              >
                <AccordionTrigger className="font-heading text-lg tracking-tight text-foreground hover:no-underline py-5 text-left font-semibold">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5 text-left">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
